var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8753 14.8078C16.8756 14.7144 16.855 14.6221 16.815 14.5378C16.775 14.4534 16.7166 14.3791 16.644 14.3203L12.894 11.3015C12.7822 11.2096 12.6419 11.1593 12.4972 11.1593C12.3524 11.1593 12.2121 11.2096 12.1003 11.3015L8.35029 14.4265C8.22266 14.5326 8.14239 14.685 8.12716 14.8503C8.11192 15.0156 8.16296 15.1801 8.26904 15.3078C8.37513 15.4354 8.52758 15.5157 8.69284 15.5309C8.85811 15.5461 9.02266 15.4951 9.15029 15.389L12.5003 12.5953L15.8503 15.2953C15.942 15.3717 16.0537 15.4202 16.1722 15.4352C16.2907 15.4501 16.4109 15.4308 16.5188 15.3795C16.6266 15.3282 16.7175 15.2471 16.7807 15.1458C16.8439 15.0445 16.8767 14.9272 16.8753 14.8078Z",
    fill: "#1E3304",
    fillOpacity: 0.91
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiThreeDots);
export default __webpack_public_path__ + "static/media/bi_three-dots.ed1c5bfe.svg";
export { ForwardRef as ReactComponent };